import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import {
  SecondAds,
  FirstAds,
  MobileUnderCalAds,
} from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "احسب قيمة الذهب بسهولة ودقة - حاسبة تحويل قيراط الذهب";
const DESCRIPTION =
  "تقوم هذه الحاسبة بحساب وزن الذهب في عيارات مختلفة بناءً على الوزن الأصلي للذهب والعيار المحدد";
const KEYWORDS = "تحويل عيار الذهب , قيراط ";
const OG_URL = "https://do-calculate.com/calculator/ar/gold-karat/";
function GoldKaratCalculator() {
  const [goldWeight, setGoldWeight] = useState(1.0);
  const [goldKarat, setGoldKarat] = useState(24);
  const [conversionResults, setConversionResults] = useState(null);
  const [error, setError] = useState(null);
  const handleGoldWeightChange = (event) => {
    setGoldWeight(event.target.value);
  };
  const handleGoldKaratChange = (event) => {
    setGoldKarat(event.target.value);
  };
  const calculateGoldKarat = () => {
    // Validate inputs
    const weight = parseFloat(goldWeight);
    const karat = parseFloat(goldKarat);
    if (isNaN(weight) || weight <= 0) {
      setError("يُرجى إدخال وزن صحيح أكبر من الصفر");
      setConversionResults(null);
      return;
    }
    if (isNaN(karat) || karat <= 0 || karat > 24) {
      setError("يُرجى إدخال عيار صحيح بين 1 و 24");
      setConversionResults(null);
      return;
    }
    try {
      // Calculate pure gold weight from original karat
      const pureGoldWeight = weight * (karat / 24);
      // Convert to each target karat
      const results = {};
      const targetKarats = [24, 22, 21, 18, 14, 10];
      targetKarats.forEach(targetKarat => {
        // Formula: convertedWeight = pureGoldWeight / (targetKarat / 24)
        // Which simplifies to: pureGoldWeight * (24 / targetKarat)
        const convertedWeight = pureGoldWeight * (24 / targetKarat);
        results[`karat_${targetKarat}`] = convertedWeight.toFixed(4);
      });
      setConversionResults(results);
      setError(null);
    } catch (err) {
      console.error(err);
      setError("حدث خطأ غير متوقع. يُرجى المحاولة مرة أخرى.");
      setConversionResults(null);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <b> حاسبة تحويل عيار (قيراط) الذهب إلى عيارات مختلفة </b>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                تقوم هذه الحاسبة بحساب وزن الذهب في عيارات مختلفة بناءً على
                الوزن الأصلي للذهب والعيار المحدد <br />
                هذه الحاسبة تهدف إلى تحويل وزن الذهب من عيار واحد إلى عيارات
                مختلفة
                <br />
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col calculatorStyle" style={{ minWidth: "300px" }}>
                <div className="p-3 mb-2 bg-success text-white">
                  حاسبة تحويل عيار (قيراط) الذهب إلى عيارات مختلفة
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <label htmlFor="goldWeight" className="form-label ms-2">
                    الوزن الأصلي للذهب:
                  </label>
                  <input
                    type="number"
                    id="goldWeight"
                    value={goldWeight}
                    onChange={handleGoldWeightChange}
                    className="form-control"
                    style={{ width: "100%", marginLeft: "10px" }}
                    placeholder="مثال: 27.7"
                    step="0.01"
                    min="0"
                  />
                  <label htmlFor="goldKarat" className="form-label ms-2">
                    عيار الذهب الأصلي:
                  </label>
                  <select
                    id="goldKarat"
                    style={{ width: "90%" }}
                    className="form-select"
                    value={goldKarat}
                    onChange={handleGoldKaratChange}
                  >
                    <option value="24">24</option>
                    <option value="22">22</option>
                    <option value="21">21</option>
                    <option value="18">18</option>
                    <option value="14">14</option>
                    <option value="10">10</option>
                  </select>
                </div>
                <br />
                <hr />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateGoldKarat}
                >
                  إحسب
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-auto">
                <br />
                {error && (
                  <div className="alert alert-danger">
                    <b>
                      <u> حدث خطأ :</u>
                    </b>{" "}
                    {error}{" "}
                  </div>
                )}
                {conversionResults && (
                  <div className="mt-4 p-3 alert alert-success">
                    <h3>النتائج:</h3>
                    <p>
                      إذا كان لديك <b>{goldWeight}</b> جرام من الذهب عيار{" "}
                      <b>{goldKarat}</b>، فإن قيمة هذا الذهب تعادل:
                    </p>
                    <ul className="list-group">
                      {Object.entries(conversionResults).map(
                        ([karatKey, weight]) => (
                          <li key={karatKey} className="list-group-item">
                            {parseFloat(weight).toFixed(2)} جرام من الذهب عيار{" "}
                            {karatKey.replace("karat_", "")}
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                وصف حاسبة تحويل عيار (قيراط) الذهب إلى عيارات مختلفة :
              </div>
              <div className="info-section-body">
                <u>
                  <b> تحويل عيار (قيراط) الذهب إلى عيارات مختلفة: </b>{" "}
                </u>{" "}
                <br/>                تعمل هذه الحاسبة على تحويل وزن الذهب من عيار واحد إلى عيارات
                مختلفة. تستلم الحاسبة وزن الذهب والعيار الأصلي كمدخلات. تتأكد
                الحاسبة من صحة الإدخالات المستلمة، بحيث يجب أن يكون الوزن
                والعيار أكبر من الصفر وألا يتجاوز العيار الأصلي 24 قيراط (الذهب
                الخالص).
                <br />
                بناءً على الوزن والعيار الأصلي، تقوم الحاسبة بحساب الوزن المعادل
                للذهب في كل عيار من العيارات المدعومة (24، 22، 21، 18، 14، 10).
                يتم حساب محتوى الذهب الخالص أولاً، ثم تحويله إلى العيارات المختلفة.
                <br/>                في نهاية الحساب، يتم عرض الأوزان المحسوبة لكل عيار بدقة.
                <br/>                هذه الحاسبة تسهل عملية تحويل وزن الذهب بين عيارات مختلفة بسهولة
                ودقة، حتى لو لم يكن لديك معرفة متخصصة في هذا المجال.
                <br />
                <hr />
                <div className="alert alert-info">
                  <b>مثال توضيحي:</b>
                  <br />
                  إذا كان لديك 27.7 جرام من الذهب عيار 22:
                  <ul>
                    <li>محتوى الذهب الخالص = 27.7 × (22/24) = 25.39 جرام</li>
                    <li>التحويل إلى عيار 24 = 25.39 جرام (أقل من الوزن الأصلي)</li>
                    <li>التحويل إلى عيار 18 = 25.39 × (24/18) = 33.85 جرام (أكثر من الوزن الأصلي)</li>
                  </ul>
                  <b>قاعدة مهمة:</b> عند التحويل إلى عيار أعلى، يقل الوزن. وعند التحويل إلى عيار أقل، يزيد الوزن.
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GoldKaratCalculator;